import { Component } from '@angular/core';
import { SelectTemplate } from 'src/app/@amiga-pyme/select/templates/select.template';
import { ProductsOfProviderService } from '../../products-of-provider.service';
import {
  IProductOfProvider,
  PRODUCTS_OF_PROVIDER_TTL_ES
} from '../../products-of-provider.interface';

@Component({
  selector: 'pg-products-of-prov-select',
  template: `
    <ami-select
      [settings]="table.settings"
      [data]="table.data"
      (selectedRowsEvent)="onReciveSelectedRows($event)"
    ></ami-select>
  `
})
export class ProductsOfProviderSelectComponent extends SelectTemplate {
  constructor(private serviceBase: ProductsOfProviderService) {
    super(PRODUCTS_OF_PROVIDER_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: PRODUCTS_OF_PROVIDER_TTL_ES,
      columns: [
        { header: 'Nombre del proveedor', field: 'providerName' },
        { header: 'Unidad de medida', field: 'unitMeasureDescription' },
        { header: 'Descripción', field: 'description' },
        { header: 'Simbolo de unidad de medida', field: 'unitMeasureSymbol' }
      ]
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IProductOfProvider[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
